export default __webpack_public_path__ + "static/media/about.5ad59bea.jpg";